import request from '@/config/axios'

export const getCreatorApplyPage = (params: any) => {
  return request.get({ url: '/scenic/creator-apply/page', params })
}

export const getCreatorApply = (id: number) => {
  return request.get({ url: '/scenic/creator-apply/get', params: { id } })
}

export const createCreatorApply = (data: any) => {
  return request.post({ url: '/scenic/creator-apply/create', data })
}

export const updateCreatorApply = (data: any) => {
  return request.put({ url: '/scenic/creator-apply/update', data })
}

export const auditCreatorApply = (data: { id: number; status: number; auditRemark?: string }) => {
  return request.put({ url: '/scenic/creator-apply/audit', data })
}

export const deleteCreatorApply = (id: number) => {
  return request.delete({ url: '/scenic/creator-apply/delete', params: { id } })
}
